import type React from 'react';

export const stopPropagation = (e: React.MouseEvent): void => {
  e.stopPropagation();
};
